function updatePlaceholder() {
    const input = document.getElementById('zip-field');
    if (input) {
        input.placeholder = window.innerWidth < 420 ? 'Zip/Postal Code' : 'Enter Zip/Postal Code';
    }
}

window.addEventListener('load', updatePlaceholder);
window.addEventListener('resize', updatePlaceholder);

// breadcrumb navigation
document.addEventListener('DOMContentLoaded', function() {
  const prevBtn = document.getElementById('breadcrumb_previous');
  const nextBtn = document.getElementById('breadcrumb_next');
  const crumbs = document.querySelectorAll('.crumb');
  
  if (!prevBtn || !nextBtn || !crumbs.length) return;
  
  function updateButtons() {
    const activeCrumb = document.querySelector('.crumb.active');
    const activeIndex = Array.from(crumbs).indexOf(activeCrumb);
    
    prevBtn.style.display = activeIndex === 0 ? 'none' : '';
    nextBtn.style.display = activeIndex === crumbs.length - 1 ? 'none' : '';
  }
  
  prevBtn.addEventListener('click', function() {
    const activeCrumb = document.querySelector('.crumb.active');
    const activeIndex = Array.from(crumbs).indexOf(activeCrumb);
    
    if (activeIndex > 0) {
      activeCrumb.classList.remove('active');
      crumbs[activeIndex - 1].classList.add('active');
      updateButtons();
    }
  });
  
  nextBtn.addEventListener('click', function() {
    const activeCrumb = document.querySelector('.crumb.active');
    const activeIndex = Array.from(crumbs).indexOf(activeCrumb);
    
    if (activeIndex < crumbs.length - 1) {
      activeCrumb.classList.remove('active');
      crumbs[activeIndex + 1].classList.add('active');
      updateButtons();
    }
  });
  
  updateButtons();
});

function reorderEstimateStepper(wrapper) {
  const input = wrapper.querySelector('input[type="number"]');
  const up = wrapper.querySelector('.increment');
  const down = wrapper.querySelector('.decrement');
  if (!input || !up || !down) {
    return;
  }
  wrapper.appendChild(down);
  wrapper.appendChild(input);
  wrapper.appendChild(up);
}

function getEstimateQuantityMin(input) {
  const min = parseFloat(input.getAttribute('min'));
  return isNaN(min) ? 0 : min;
}

function clampEstimateQuantityValue(input) {
  const min = getEstimateQuantityMin(input);
  const max = parseFloat(input.getAttribute('max'));
  let value = parseFloat(input.value);

  if (isNaN(value)) {
    return;
  }

  if (value < min) {
    value = min;
  }

  if (!isNaN(max) && value > max) {
    value = max;
  }

  input.value = value;
}

function initCustomEstimateFormUI(root) {
  const scope = root || document;
  const estimateRoot = '.request-fast-estimate .gform_wrapper';

  scope.querySelectorAll(estimateRoot + ' input[type="number"]').forEach(function (input) {
    let wrapper = input.closest('.number-input');

    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'number-input';
      input.parentNode.insertBefore(wrapper, input);
      wrapper.appendChild(input);
    }

    let up = wrapper.querySelector('.increment');
    let down = wrapper.querySelector('.decrement');

    if (!up) {
      up = document.createElement('button');
      up.type = 'button';
      up.className = 'increment';
      up.setAttribute('aria-label', 'Increase value');
      wrapper.appendChild(up);
    }

    if (!down) {
      down = document.createElement('button');
      down.type = 'button';
      down.className = 'decrement';
      down.setAttribute('aria-label', 'Decrease value');
      wrapper.appendChild(down);
    }

    up.innerHTML = '+';
    down.innerHTML = '\u2212';
    up.setAttribute('aria-label', 'Increase value');
    down.setAttribute('aria-label', 'Decrease value');
    reorderEstimateStepper(wrapper);
    input.setAttribute('min', '0');

    if (!input.dataset.boundQuantityClamp) {
      input.dataset.boundQuantityClamp = '1';
      input.addEventListener('input', function () {
        clampEstimateQuantityValue(input);
      });
      input.addEventListener('change', function () {
        clampEstimateQuantityValue(input);
      });
    }

    if (!up.dataset.bound) {
      up.dataset.bound = '1';
      up.addEventListener('click', function () {
        let current = parseFloat(input.value);
        let step = parseFloat(input.getAttribute('step'));

        if (isNaN(step) || step <= 0) {
          step = 1;
        }

        if (isNaN(current)) {
          current = 0;
        }

        const min = getEstimateQuantityMin(input);
        const max = parseFloat(input.getAttribute('max'));
        let next = current + step;

        if (next < min) next = min;
        if (!isNaN(max) && next > max) next = max;

        input.value = next;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    if (!down.dataset.bound) {
      down.dataset.bound = '1';
      down.addEventListener('click', function () {
        let current = parseFloat(input.value);
        let step = parseFloat(input.getAttribute('step'));

        if (isNaN(step) || step <= 0) {
          step = 1;
        }

        if (isNaN(current)) {
          current = 0;
        }

        const min = getEstimateQuantityMin(input);
        const max = parseFloat(input.getAttribute('max'));
        let next = current - step;

        if (next < min) next = min;
        if (!isNaN(max) && next > max) next = max;

        input.value = next;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });

  scope.querySelectorAll(
    '.request-fast-estimate .bedrooms-field input[type="number"],' +
    '.request-fast-estimate .pets-field input[type="number"],' +
    '.request-fast-estimate .full-bathrooms-field input[type="number"],' +
    '.request-fast-estimate .half-bathrooms-field input[type="number"]'
  ).forEach(function (input) {
    input.setAttribute('placeholder', '0');
  });

  scope.querySelectorAll('.request-fast-estimate .frequency-form-field select').forEach(function (select) {
    const container = select.closest('.ginput_container_select');
    if (!container) return;

    const selectOption = Array.from(select.options).find(function (opt) {
      return opt.textContent.trim() === 'Select';
    });

    if (selectOption) {
      selectOption.textContent = '';
      if (typeof selectOption.value === 'string' && selectOption.value.toLowerCase() === 'select') {
        selectOption.value = '';
      }
      if (!select.value) {
        select.value = selectOption.value;
      }
    }

    function toggleFrequencyLabel() {
      if (select.value && select.value !== '') {
        container.classList.add('has-value');
      } else {
        container.classList.remove('has-value');
      }
    }

    if (!select.dataset.boundFrequency) {
      select.dataset.boundFrequency = '1';
      select.addEventListener('change', toggleFrequencyLabel);
    }

    toggleFrequencyLabel();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initCustomEstimateFormUI(document);
});

document.addEventListener('gform_post_render', function () {
  initCustomEstimateFormUI(document);
});

document.addEventListener('gform_page_loaded', function () {
  initCustomEstimateFormUI(document);
});

if (window.jQuery) {
  window.jQuery(document).on('gform_post_render gform_page_loaded', function () {
    initCustomEstimateFormUI(document);
  });
}